import React , { useMemo } from 'react'

export default function Clients({client, repeat = 4, speed = 80}) {
    const duplicatedList = useMemo(() => {
        let arr = [];
        for (let i = 0; i < repeat; i++) {
        arr = [...arr, ...client];
        }
        return arr;
    }, [client, repeat]); 
  return (
    <div className='py-3'>
        <div className='marquee-container'>
            <div className='marquee-track new-marquee-brand' style={{ animationDuration: `${speed}s` }}>
                {duplicatedList.map((item, index) => (
                    <div key={index} className="marquee-item new-card-brand">
                        <img src={item.image} className="img-fluid" alt="" />
                    </div>
                ))}
            </div>
        </div>
    </div>
  )
}

